import { ReactElement } from 'react';
import { IconsMap } from '@nx-frontend/shared/ui/icon/icon';
import { MenuItemType } from '@nx-frontend/shared/types/menu';

export const MenuTreeDefaultIcon: Record<MenuItemType, ReactElement> = {
  [MenuItemType.HOME]: IconsMap.HOME,
  [MenuItemType.NOTE]: IconsMap.DOCUMENT,
  [MenuItemType.NOTES_FOLDER]: IconsMap.FOLDER,
  [MenuItemType.FOLDERS]: IconsMap.FOLDER,
  [MenuItemType.LINK]: IconsMap.LINK_1,
  [MenuItemType.PORTAL_PAGE]: IconsMap.DOCUMENT,
  [MenuItemType.PORTAL_SECTION]: IconsMap.FOLDER,
  [MenuItemType.PORTAL_PROCESS]: IconsMap.FOLDER,
  [MenuItemType.UNKNOWN]: IconsMap.DOCUMENT,
  [MenuItemType.TASKS]: IconsMap.TASKS,
  [MenuItemType.CHAT]: IconsMap.CHAT_1,
  [MenuItemType.ALL_PAGES]: IconsMap.DOCUMENT,
  [MenuItemType.FILES]: IconsMap.PAPERCLIP,
  [MenuItemType.FILES_MANAGER]: IconsMap.PAPERCLIP,
  [MenuItemType.TASKS_DASHBOARD]: IconsMap.TASKS,
  [MenuItemType.CHATS_DASHBOARD]: IconsMap.CHAT_1,
  [MenuItemType.TAGS]: IconsMap.TAG,
  [MenuItemType.TAG]: IconsMap.TAG,
  [MenuItemType.AI_AGENTS]: IconsMap.AI_AGENT_ROBOT,
};

export function getMenuItemIcon({ type, icon }: { type: MenuItemType; icon?: string }) {
  if (icon && icon.length) {
    if (icon === 'page') {
      return IconsMap.DOCUMENT;
    }
    if (icon === 'folder') {
      return IconsMap.FOLDER;
    }
    if (icon === 'folders') {
      return IconsMap.FOLDERS;
    }
    if (icon === 'tasks') {
      return IconsMap.TASKS;
    }
    if (icon === 'paperclip') {
      return IconsMap.PAPERCLIP;
    }
    if (icon === 'chat') {
      return IconsMap.CHAT_1;
    }
    if (icon === 'chat-badge') {
      return IconsMap.CHAT_WITH_BADGE;
    }
    if (icon === 'process') {
      return IconsMap.PROCESS;
    }
    if (icon === 'process_done') {
      return IconsMap.PROCESS_DONE;
    }
    if (icon === 'process_step') {
      return IconsMap.PROCESS_STEP;
    }
    if (icon === 'process_step_done') {
      return IconsMap.PROCESS_STEP_DONE;
    }
    if (icon === 'tag') {
      return IconsMap.TAG;
    }
    if (icon === 'ai_agents') {
      return IconsMap.AI_AGENT_ROBOT;
    }
    if (icon === 'linked_document') {
      return IconsMap.LINKED_DOCUMENT;
    }
    if (icon === 'linked_folder') {
      return IconsMap.LINKED_FOLDER;
    }
  }
  return getDefaultItemIcon(type);
}

function getDefaultItemIcon(type: MenuItemType) {
  return MenuTreeDefaultIcon[type];
}
